// extracted by mini-css-extract-plugin
export var cardContainer = "_ov-0";
export var cardHeader = "_ov-2";
export var collapsedState = "_ov-3";
export var dragHandle = "_ov-5";
export var dragHandleIcon = "_ov-6";
export var dragging = "_ov-1";
export var titleArea = "_ov-4";